export const fetchConfig: RequestInit = {
  credentials: 'include',
  mode: 'cors'
};